import { useState, useEffect } from "react";
import { Turnstile } from "@marsidev/react-turnstile";

function FooterForm() {
  const [turnstileToken, setTurnstileToken] = useState("");
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const APP_SCRIPT_URL = process.env.REACT_APP_SCRIPT_URL;
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    setFormData((prev) => ({
      ...prev,
      [name]:
        name === "phone"
          ? value.replace(/\D/g, "").slice(0, 10)
          : value,
    }));
  
    setErrors((prev) => ({
      ...prev,
      [name]: "",
      submit: "",
    }));

  };
  const validateForm = () => {
    const newErrors = {};

    // Name
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    // Email
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Enter a valid email";
    }

    // Phone
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      newErrors.phone = "Enter a valid 10-digit phone number";
    }

    // Message
    if (!formData.message.trim()) {
      newErrors.message = "Project description is required";
    } else if (formData.message.trim().length < 15) {
      newErrors.message = "Please enter at least 15 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const validateField = (name, value) => {
    let error = "";
  
    switch (name) {
      case "name":
        if (!value.trim()) error = "Name is required";
        break;
  
      case "email":
        if (!value.trim()) {
          error = "Email is required";
        } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)
        ) {
          error = "Enter a valid email";
        }
        break;
  
      case "phone":
        if (!value.trim()) {
          error = "Phone number is required";
        } else if (!/^[6-9]\d{9}$/.test(value)) {
          error = "Enter a valid 10-digit phone number";
        }
        break;
  
      case "message":
        if (!value.trim()) {
          error = "Project description is required";
        } else if (value.trim().length < 15) {
          error = "Please enter at least 15 characters";
        }
        break;
  
      default:
        break;
    }
  
    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  // useEffect(() => {
  //   console.log("Site Key:", process.env.REACT_APP_TURNSTILE_SITE_KEY);
  // }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
  
    if (!turnstileToken) {
      setErrors((prev) => ({
        ...prev,
        submit: "Please complete verification.",
      }));
      return;
    }
  
    const payload = {
      source: "GrowX Website",
      name: formData.name.trim(),
      email: formData.email.trim(),
      phone: formData.phone.trim(),
      message: formData.message.trim(),
      token: "growx_secure_2026",
      company: "",
      turnstileToken,
    };
  
    try {
      setLoading(true);
  
      const response = await fetch(APP_SCRIPT_URL, {
        method: "POST",
        body: JSON.stringify(payload),
      });
  
      const result = await response.json();
  
      if (result.success) {
        alert("Message sent successfully!");
  
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
  
        setErrors({});
        setTurnstileToken("");
      } else {
        setErrors((prev) => ({
          ...prev,
          submit: result.message || "Submission failed.",
        }));
      }
    } catch (error) {
      // console.error(error);
  
      setErrors((prev) => ({
        ...prev,
        submit: "Something went wrong. Please try again.",
      }));
    } finally {
      setLoading(false);
    }
  };
  // console.log("Site Key:", process.env.REACT_APP_TURNSTILE_SITE_KEY);
  return (

    <div className="max-w-4xl mx-auto mt-8 sm:mt-14 px-4 sm:px-6">
      <div className="bg-white rounded-2xl sm:rounded-3xl p-5 sm:p-8 md:p-10 shadow-2xl">
        <h3 className="text-2xl sm:text-3xl font-bold text-gray-900">
          Let's Build Something Amazing 🚀
        </h3>

        <p className="mt-2 sm:mt-3 mb-5 sm:mb-8 text-[13px] sm:text-base text-gray-600 leading-6 sm:leading-7">
          Have a project in mind? Fill out the form below and our team will get
          in touch with you within{" "}
          <span className="font-semibold text-purple-600">24 hours.</span>
        </p>

        <form onSubmit={handleSubmit}>
   
          {/* Top Row */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
            {/* Name */}
            <div>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                onBlur={(e) => validateField(e.target.name, e.target.value)}
                placeholder="Your Name"
                className={`w-full rounded-xl border bg-gray-50 text-gray-700 px-5 py-4 text-sm sm:text-base outline-none transition ${
                  errors.name
                    ? "border-red-500 focus:ring-2 focus:ring-red-200"
                    : "border-gray-200 focus:border-purple-500 focus:ring-4 focus:ring-purple-100"
                }`}
              />

              {errors.name && (
                <p className="mt-1 text-sm text-red-500">{errors.name}</p>
              )}
            </div>

            {/* Email */}
            <div>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                onBlur={(e) => validateField(e.target.name, e.target.value)}
                placeholder="Email Address"
                className={`w-full rounded-xl border bg-gray-50 text-gray-700 px-5 py-4 text-sm sm:text-base outline-none transition ${
                  errors.email
                    ? "border-red-500 focus:ring-2 focus:ring-red-200"
                    : "border-gray-200 focus:border-purple-500 focus:ring-4 focus:ring-purple-100"
                }`}
              />

              {errors.email && (
                <p className="mt-1 text-sm text-red-500">{errors.email}</p>
              )}
            </div>

            {/* Phone */}
            <div>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                onBlur={(e) => validateField(e.target.name, e.target.value)}
                placeholder="Phone Number"
                maxLength={10}
                className={`w-full rounded-xl border bg-gray-50 text-gray-700 px-5 py-4 text-sm sm:text-base outline-none transition ${
                  errors.phone
                    ? "border-red-500 focus:ring-2 focus:ring-red-200"
                    : "border-gray-200 focus:border-purple-500 focus:ring-4 focus:ring-purple-100"
                }`}
              />

              {errors.phone && (
                <p className="mt-1 text-sm text-red-500">{errors.phone}</p>
              )}
            </div>
          </div>

          {/* Message */}
          <div className="mt-4 sm:mt-6">
            <textarea
              rows="5"
              name="message"
              value={formData.message}
              onBlur={(e) => validateField(e.target.name, e.target.value)}
              onChange={handleChange}
              placeholder="Tell us about your project..."
              className={`w-full rounded-xl border bg-gray-50 text-gray-700 px-5 py-4 text-sm mb-2 lg:mb-0 sm:text-base resize-none outline-none transition ${
                errors.message
                  ? "border-red-500 focus:ring-2 focus:ring-red-200"
                  : "border-gray-200 focus:border-purple-500 focus:ring-4 focus:ring-purple-100"
              }`}
            />

            {errors.message && (
              <p className="mt-1 mb-2 text-sm text-red-500">{errors.message}</p>
            )}
          </div>
            {/* Captcha */}
            <Turnstile
            className="h-1 rounded-xl lg:mt-4 "
                siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
                onSuccess={(token) => {
                  setTurnstileToken(token);
                }}
                options={{
                  theme: "light",
                  size: "normal",
                }}
              />

              {errors.submit && (
                <p className="mt-2 text-sm text-red-500">
                  {errors.submit}
                </p>
              )}
          {/* Button */}
          <div className="flex justify-end mt-4 lg:mt-0">
          <button
            type="submit"
            disabled={loading}
            className={`rounded-xl px-8 sm:px-10 py-3.5 sm:py-4 text-sm sm:text-base font-semibold text-white shadow-lg transition-all duration-300
              ${
                loading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-gradient-to-r from-indigo-600 to-purple-600 hover:scale-105 hover:shadow-2xl"
              }`}
          >
            {loading ? "Sending..." : "Send Message"}
          </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default FooterForm;